$(function () {
    $("#top-images").owlCarousel({
        items: 1,
        loop: $("#top-images .col-img").length > 1,
        dots: false,
        nav: true,
        margin: 2,
        touchDrag: $("#top-images .col-img").length > 1,
        mouseDrag: $("#top-images .col-img").length > 1,
        navText: [
            '<i class="fas fa-angle-left"></i>',
            '<i class="fas fa-angle-right"></i>',
        ],
    });

    $("#view-floor-plan-images").owlCarousel({
        items: 1,
        loop: $("#view-floor-plan-images .col-img").length > 1,
        dots: false,
        nav: true,
        touchDrag: $("#view-floor-plan-images .col-img").length > 1,
        mouseDrag: $("#view-floor-plan-images .col-img").length > 1,
        navText: [
            '<i class="fas fa-angle-left"></i>',
            '<i class="fas fa-angle-right"></i>',
        ],
    });

    $(".top-view-floor-plan-images").owlCarousel({
        items: 1,
        loop: false,
        dots: false,
        nav: true,
        touchDrag: false,
        mouseDrag: false,
        navText: [
            '<i class="fas fa-angle-left"></i>',
            '<i class="fas fa-angle-right"></i>',
        ],
    });

    var zoom_percent = "100";
    function zoom(zoom_percent) {
        $(".mfp-figure figure").hover(function () {
            // $(".mfp-img").BUP(null, 1.5);
            $(this).on("mousewheel DOMMouseScroll", function (event) {
                console.log(event.originalEvent.deltaY);
                if (event.originalEvent.deltaY < 0) {
                    switch (zoom_percent) {
                        case "100":
                            zoom_percent = "110";
                            break;
                        case "110":
                            zoom_percent = "120";
                            break;
                        case "120":
                            zoom_percent = "130";
                            break;
                        case "130":
                            zoom_percent = "140";
                            break;
                        case "140":
                            zoom_percent = "150";
                            break;
                        case "150":
                            zoom_percent = "160";
                            break;
                    }
                } else {
                    switch (zoom_percent) {
                        case "160":
                            zoom_percent = "150";
                            break;
                        case "150":
                            zoom_percent = "140";
                            break;
                        case "140":
                            zoom_percent = "130";
                            break;
                        case "130":
                            zoom_percent = "120";
                            break;
                        case "120":
                            zoom_percent = "110";
                            break;
                        case "110":
                            zoom_percent = "100";
                            break;
                    }
                }
                $(this).css("zoom", zoom_percent + "%");
            });
        });
    }

    $(".img-pop").magnificPopup({
        type: "image",
        closeOnBgClick: true,
        enableEscapeKey: true,
        callbacks: {
            open: function () {
                // $(".mfp-figure figure").css("cursor", "zoom-in");
                zoom(zoom_percent);
            },
            close: function () {
                // Will fire when popup is closed
            },
            // e.t.c.
        },
    });

    // adjustHeight();

    $(".contact-form").submit(function (e) {
        e.preventDefault();

        if (addErrorMessage() == false) {
            return false;
        }

        let fullname = $(".contact-form #fullname").val().trim();
        let email = $(".contact-form #email").val().trim();
        let phone = $(".contact-form #contact-no").val().trim();
        let properties = $(".contact-form #properties").val().trim();
        let details = $(".contact-form #details").val().trim();

        $.ajax({
            type: "GET",
            url: $(".contact-form").attr("action"),
            data: {
                fullname: fullname,
                email: email,
                contact_no: phone,
                properties: properties,
                details: details,
            },
            success: function (result) {
                if (result.valid == "success") {
                    $("#contact-modal").modal("show");
                    $(".contact-form")[0].reset();
                } else {
                    ajaxErrorMessage(result);
                    alert("メール通信に問題が発生しました。");
                }
            },
            error: function (error) {},
        });
    });
});

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function ajaxErrorMessage(result) {
    let errors = result.errors;
    console.log(errors);

    Object.entries(errors).map((err) => {
        console.log(err);
        switch (err[0]) {
            case "fullname":
                $(".contact-form #fullname").addClass("is-invalid");
                $(".fullname-required").removeClass("d-none");
                has_error = true;
                break;

            case "email":
                $(".contact-form #email").addClass("is-invalid");
                $(".email-required").removeClass("d-none");
                has_error = true;
                break;

            case "details":
                $(".contact-form #details").addClass("is-invalid");
                $(".details-required").removeClass("d-none");
                has_error = true;
                break;

            default:
                break;
        }
    });
}

function addErrorMessage() {
    let fullname = $(".contact-form #fullname").val().trim();
    let email = $(".contact-form #email").val().trim();
    let phone = $(".contact-form #contact-no").val().trim();
    let properties = $(".contact-form #properties").val().trim();
    let details = $(".contact-form #details").val().trim();

    $(".contact-form #fullname").removeClass("is-invalid");
    $(".fullname-required").addClass("d-none");
    $(".contact-form #email").removeClass("is-invalid");
    $(".email-required").addClass("d-none");
    $(".email-format").addClass("d-none");
    $(".contact-form #details").removeClass("is-invalid");
    $(".details-required").addClass("d-none");
    let has_error = false;

    if (fullname == "") {
        $(".contact-form #fullname").addClass("is-invalid");
        $(".fullname-required").removeClass("d-none");
        has_error = true;
    } else {
        // do nothing
    }
    if (email == "") {
        $(".contact-form #email").addClass("is-invalid");
        $(".email-required").removeClass("d-none");
        has_error = true;
    } else if (!isEmail(email)) {
        $(".contact-form #email").addClass("is-invalid");
        $(".email-format").removeClass("d-none");
        has_error = true;
    } else {
        // do nothing
    }
    if (details == "") {
        $(".contact-form #details").addClass("is-invalid");
        $(".details-required").removeClass("d-none");
        has_error = true;
    } else {
        // do nothing
    }
    if (has_error) {
        return false;
    }
}

// $(window).resize(() => {
//     setTimeout(() => {
//         adjustHeight();
//     }, 80);
// });

// adjust tile container height
// function adjustHeight() {
//     setTimeout(() => {
//         let image_height = $(".top-images div.active img").height();
//         let paddingTop = parseInt($(".property-images").css("padding-top"));
//         let paddingBottom = parseInt($(".property-images").css("padding-bottom"));
//         $(".property-images").height(image_height - paddingTop - paddingBottom);

//         let title_div_height = $("#title-and-images .container-title").height();
//         $("#title-and-images").height(title_div_height + image_height);
//         $("#title-and-images #top-images").height(image_height);
//     }, 80);
// }
